import { create } from 'zustand';

type NotificationSeverity = 'warning' | 'error' | 'info' | 'success';

interface NotificationState {
  message: string;
  severity: NotificationSeverity;
  open: boolean;
  showNotification: (message: string, severity: NotificationSeverity) => void;
  closeNotification: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  message: '',
  severity: 'warning',
  open: false,
  showNotification: (message, severity) => set({ message, severity, open: true }),
  closeNotification: () => set({ open: false }),
}));
